import { useEffect } from "react";

const useUTMToLocalStorage = (
  utmKeys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
  ],
) => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    utmKeys.forEach((key) => {
      const value = params.get(key);
      if (value) {
        localStorage.setItem(key, value);
      }
    });
  }, [utmKeys]);
};

export { useUTMToLocalStorage };
